import { isMobile } from "react-device-detect";

export const UI_USER_SELECTION_PANEL = {
  CONTAINER_EXCESS_HEIGHT: 100,
  USER_ELEMENT_HEIGHT: isMobile ? 44 : 48
};
